import $ from 'jquery/src/jquery'
import {pageScroll} from "../helpers";
export default () => {
    const nodeSelectors = {
        container: '[js-video="container"]',
        playBtn: '[js-video="play-button"]',
        cover: '[js-video="cover"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        $(nodeSelectors.container).each(function () {
            let videoEl = $(this).find('video')
            let button = $(this).find(nodeSelectors.playBtn)
            let buttonIcon = button.find('img')
            let cover = $(this).find(nodeSelectors.cover)
            let video = videoEl[0]

            $(button).on('click', function () {
                if( video.paused ) {
                    cover.hide()
                    buttonIcon.hide()
                    video.play()
                } else {
                    cover.show()
                    buttonIcon.show()
                    video.pause()
                }
            })
        })
    }

    return Object.freeze({
        init,
    })
}